





























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter } from "@/components";
import { TbGoods, TbGoodsClass } from '@/http';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import remarkPanel from "./components/remarkPanel.vue"
import unFinishProduct from "./components/unFinishProduct.vue"
import pdTipPanel from "./components/pdTipPanel.vue"
import { TbStocktaking } from '@/http/api_TbStocktaking';
@Component({
    components: {
        padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter,remarkPanel,unFinishProduct,pdTipPanel
    },
})
export default class addInventory extends Vue {
    public $refs: {
    };

    pdList=[];

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**查询项 */
    searchValue = {
        name:"",
        goodsClassId:"",
        skip:0,
        count:5,
    }
    showspPopover = false;

    className = "";

    userInfo:any={};

    /**新增分类弹窗 */
    /**新增分类类型
     * true：一级分类
     * false：二级分类
     */
     isParent=true;

     addClassShow = false;
    /**一级分类信息 */
    firstInfo:any={};

    /**商品分类列表 */
    classList=[];
    checkClassId=[];
    checkClassName=[];

    isSaving = false;

    searchTimer: any = null;

    Loop=null;
    deleteIndex=null;

    //搜索商品字段
    option3 = [];
    isPinyinPro = false;

    /**全库盘点统计 */
    totalInfo={
        goodsSKUTotal:0,
        allBeforeTotal:0,
    };
    /**盘点备注 */
    remarks="";

    /**未盘点信息 */
    unPdInfo:any={};
     public scanCodes:any = ''

    /**已盘点商品sku */
    get alreadyPdSku(){
        let val = 0;
        val = this.pdList.length>0?this.pdList.length:0;
        return val;
    }

    /**盘前库存总计 */
    get beforeInventoryTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.beforeInventory).map(v=>v.beforeInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }
    /**盘后库存总计 */
    get actInventoryTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.actInventory).map(v=>v.actInventory);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }
    /**盈亏数总计 */
    get profitOrLossTotal(){
        let val = 0;
        let arr = this.pdList.filter(v=>v.profitOrLoss).map(v=>v.profitOrLoss);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        return val;
    }
    /**盘点结果 */
    get stocktakingResult(){
        let val = 1;
        if(this.profitOrLossTotal==0){
            val=1
        }else if(this.profitOrLossTotal>0){
            val = 2;
        }else if(this.profitOrLossTotal<0){
            val = 3;
        }
       
        return val;
    }

    created() {
    }
    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo')); 
        // window.webkit.messageHandlers.getFocus.postMessage('getFocus');
        await this.getTotal();
        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus) 
    }
    async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.searchValue.name = res.barCode;
            if(res.isDelete){
                this.tipTitle = "无效条形码";
                this.tipText = `商品不存在或已删除!`;
                this.btnNums=1;
                this.confirmText = "确认";
                this.cancelText = ""
                this.tipType = 6;
                this.tipShow = true;
                return;
            }else if(!res.isShelves){
                this.tipTitle = "商品已下架";
                this.tipText = `该商品已下架，不可进行盘点操作`;
                this.btnNums=1;
                this.confirmText = "确认";
                this.cancelText = ""
                this.tipType = 6;
                this.tipShow = true;
            }else{
                if (!this.userInfo.shopId) return;
                let res2 = await TbGoods.GetGoodsItemsList({name:res.barCode,shopId:this.userInfo.shopId});
                if(res2.items.length>0){
                    this.addPd(res2.items[0],'scan');
                }
            }
        }else{
            this.tipTitle = "无效条形码";
            this.tipText = `请扫描使用本收银系统生成的商品标签上的条形码!`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 6;
            this.tipShow = true;
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input'&&event.target.tagName.toLowerCase() != 'textarea') {
            this.getInputFocus()
        }
    }
    beforeDestroy() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
            this.searchTimer = null;
        }
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){
            this.searchValue.name = event.target.value
        }else{
            if (event.key === 'Enter' || event.keyCode == 13) {
                let code = this.scanCodes?this.scanCodes:event.target.value
                this.scanInput(code)
    
                this.scanCodes = ''
            return
            }
        }
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)
    }

    /**批量设置 */
    batchSet(val){
       if(this.pdList.length>0){
        this.pdList = this.pdList.map(v=>{
            return{
                ...v,
                actInventory:val,
                profitOrLoss:calculate.subtraction(val,v.beforeInventory)
            }
        })
       }
    }

    /**清空 */
    clearAll(){
        if(this.pdList.length==0) return;

        this.tipTitle = "清空提醒";
        this.tipText = `确定清空全部的盘点信息吗？`;
        this.btnNums=2;
        this.confirmText = "确定清空";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;
    }

    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            /**清空 */
            case 1:
                this.pdList = [];
                break;
            /**未添加盘点商品 */
            case 2:
                break;
            /**删除商品 */
            case 3:
                this.pdList.splice(this.deleteIndex,1);
                break;
            /**返回提醒 */
            case 4:
                this.$router.go(-1);
                break;
            case 5:
                this.$router.push("/pad/mainPage/index")
                break;
        
            default:
                break;
        }
        this.tipShow = false;
    }
    deleteFun(index){
        this.pdList.splice(index,1);
    }
    tipCancel(){
        this.tipShow = false;
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            if (!this.userInfo.shopId) return;

            let s = this.searchValue.count;
            let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId,
                isShelves:true,
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),
                    
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    clearClass(){
        this.className="";
        this.searchValue.goodsClassId = "";
        this.getClassList();
    }
    /**获取商品列表 */
    async getList(){
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        if (!this.userInfo.shopId) return;

        // this.onRefresh();
        let res = await TbGoods.GetGoodsItemsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId,
                isShelves:true,
            }))
            this.list =res.items.map(v=>{
                return{
                    ...v,
                    costPrice:v.costPrice.toFixed(2),
                    
                }
            })
            this.total  = res.totalCount;
            this.$nextTick(()=>{
                this.loading = false;
                this.isPinyinPro = false;
            })
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            name:"",
            goodsClassId:"",
            skip:0,
            count:10,
        }
        this.getList();
    }

    addClass(type){
        this.isParent = type;
        this.addClassShow=true;
        if(!type){
            this.$refs['addClassPanel'].init(this.firstInfo);
        }
    }
    addSecondClass(item){
        this.firstInfo = item;
        this.addClass(false);
    }

    closeFun(){
        this.addClassShow = false;
    }
    async confirmSave(res){
        let id = this.isParent?res.id:this.firstInfo.id+','+res.id;
        this.searchValue.goodsClassId = id;
        await this.getList();
        this.$refs['selectClassPanel'].closeFun();
    }

    /**递归搜索结果 */
    async mapClassId(data) {
        data.map((v) => {
            if (v.items && v.items.length > 0) {
                this.mapClassId(v.items);
            }
            if ( this.searchValue.goodsClassId.indexOf(",")==-1) {
                if(this.searchValue.goodsClassId==v.id){
                    this.checkClassId.push(v.id);
                    this.checkClassName.push(v.name);
                }
            }else{
                let arr = this.searchValue.goodsClassId.split(",")
                    if(arr.some(k=>k==v.id)){
                        this.checkClassId.unshift(v.id);
                        this.checkClassName.unshift(v.name);
                    }
                
            }
        });
      
    }
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:false
        }) 
        this.classList = res;
    }
    /**匹配分类名 */
    async getClassName(){
        this.checkClassId=[];
        this.checkClassName=[];
        await this.getClassList();
        await this.mapClassId(this.classList);
        if((this.searchValue.goodsClassId.indexOf(",") == -1&&this.checkClassId.length>0)||(this.searchValue.goodsClassId.indexOf(",")>-1&&this.checkClassId.length==2)){
            this.className= this.checkClassName.join('-');
           
            }else{
            this.searchValue.goodsClassId = this.classList.some(v=>v.name=='其他分类')?this.classList.find(v=>v.name=='其他分类').id:'';
            this.className="其他分类";
          
    }
    };

    chooseClass(item){
        this.searchValue.goodsClassId = item.id; 
        this.className = item.name;
    }

    addPd(item,type='hand'){
        let index = this.pdList.findIndex(v=>v.id==item.id);
        if(index>-1){
            let newObj = this.pdList[index];
            this.pdList.splice(index,1);
            this.pdList.unshift(Object.assign({},newObj,{
                actInventory:Number(newObj.actInventory)+1,
                profitOrLoss:Number(newObj.profitOrLoss)+1
            }))
        }else{
            if(type=='scan'){
                let obj = Object.assign({},item,{
                    beforeInventory:item.stock,
                    actInventory:1,
                    profitOrLoss: calculate.subtraction(1,item.stock),
                })
                this.pdList.unshift(obj);
            }else{
                let obj = Object.assign({},item,{
                    beforeInventory:item.stock,
                    actInventory:0,
                    profitOrLoss: calculate.subtraction(0,item.stock),
                })
                this.pdList.unshift(obj);

            }
        }
        this.$forceUpdate();
    }

    /**计数器 */
    finishStep(val,index){
        this.$set(this.pdList[index],'actInventory',val);
        let profitOrLoss = calculate.subtraction(val,this.pdList[index].beforeInventory)
        this.$set(this.pdList[index],'profitOrLoss',profitOrLoss);
    }

    async saveFun(){
        if(this.pdList.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `请先添加盘点商品！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 2;
            this.tipShow = true;
            return;
        }
        if(this.totalInfo.goodsSKUTotal==this.alreadyPdSku){
            this.showTip(true);
        }else{
            let ids = this.pdList.map(v=>v.id).join(',');
            this.$refs['unFinishProduct'].showFun(ids);
        }
    }

    formateArr(){
        let arr =[];
        if(this.pdList.length>0){
            arr = this.pdList.map((v,index)=>{
                return {
                    goodsId:v.goodsId,
                    goodsItemId:v.id,
                    beforeStock:v.beforeInventory,
                    laterStock:v.actInventory,
                    profitOrLoss:v.profitOrLoss,
                    stocktakingResult:v.profitOrLoss==0?1:v.profitOrLoss>0?2:3,
                    stocktakingType:1,
                    sort:index,
                }
            })
        }
        return arr;
    }

    touchstart(index){
        // if(!this.isManage)return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.deleteTip(index);
        }.bind(this), 1000);//手指或者鼠标按下等待的时间
    }
    deleteTip(index){
        this.tipTitle = "操作提醒";
        this.tipText = `确认移除该商品吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.deleteIndex = index;
        this.tipType = 3;
        this.tipShow = true;
    }
    touchend(){
        // if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }
    showClass(){
        this.$refs['selectClassPanel'].showFun(this.searchValue.goodsClassId);
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

    showPopup(){
        if(this.searchValue.name){
            this.showspPopover = true;
        }
    }
    iptStart(e) {
        this.isPinyinPro = true;
    }
  
    iptEnd1(e) {
        this.searchValue.name = e.target.value;
        this.getList();
        this.showspPopover = true;
    }
    searchFun() {
        if (this.isPinyinPro) {
            return;
        }
        if(!this.searchValue.name){
            this.showspPopover = false;
            return;
        }
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(async () => {
            await this.getList();
            this.showspPopover = true;
        }, 300);
    }
    clearSearch(){
        this.searchValue.name = "";
        this.showspPopover = false;
    }
    
    addRemark(){
        this.$refs['remarkPanel'].showFun(this.remarks);
    }
    goBacknew(){
            if(this.pdList.length>0){
                this.tipTitle = "返回提醒";
                this.tipText = `尚未完成本次全库盘点，确定返回吗？`;
                this.btnNums=2;
                this.confirmText = "确定返回";
                this.cancelText = "取消"
                this.tipType = 4;
                this.tipShow = true;
            }else{
                this.$router.go(-1);
            }
    }
    goBackHome(){
        if(this.pdList.length>0){
            this.tipTitle = "返回提醒";
            this.tipText = `尚未完成本次全库盘点，确定返回吗？`;
            this.btnNums=2;
            this.confirmText = "确定返回";
            this.cancelText = "取消"
            this.tipType = 5;
            this.tipShow = true;
        }else{
            this.$router.push("/pad/mainPage/index");
        }
    }
    /**全库统计 */
    async getTotal(){
        let res = await TbStocktaking.GetGoodsItemsTotal();
        this.totalInfo = res;
    }
    /**保存备注 */
    onSaveRemark(val){
        this.remarks = val;
    }
    /**盘点提醒 */
    showTip(val){
        this.$refs['pdTipPanel'].showFun(val);
    }
    /**完成盘点 */
    async onSave(){
        if(this.isSaving) return;
        this.isSaving = true;
        Toast.loading({
            message: "盘点中",
            duration: 0, // toast不消失
        });
        try {
            let res = await TbStocktaking.AddTbStocktaking({
                allSKU:this.totalInfo.goodsSKUTotal,
                allBefore:this.totalInfo.allBeforeTotal,
                allLater: calculate.addition(this.totalInfo.allBeforeTotal,this.profitOrLossTotal),/**盘后=盘前+盈亏 */
                alreadySKU:this.alreadyPdSku,
                alreadyBefore:this.beforeInventoryTotal,
                alreadyLater:this.actInventoryTotal,
                sansSKU:this.unPdInfo.totalCount,
                sansBefore:this.unPdInfo.allBeforeTotal,
                sansLater:this.unPdInfo.allBeforeTotal,
                stocktakingResult:this.stocktakingResult,
                profitOrLoss:this.profitOrLossTotal,
                creatorId:this.userInfo.id,
                creatorName:this.userInfo.name,
                remarks:this.remarks,
                addList:this.formateArr()
            })
            Toast("保存成功");
            this.pdList = [];
            this.onRefresh();
            this.isSaving = false;
            Toast.clear();
            this.$refs['unFinishProduct'].closeFun();
            setTimeout(()=>{
                this.$router.go(-1);
            },1000)
        } catch (error) {
            this.isSaving = false;
        }
    }
    unConfirm(item){
        this.unPdInfo = item.form;
        this.showTip(item.val);
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/addFullInventory.vue